import "./FatFooter.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const ThinFooter = () => {

	const currentYear = new Date().getFullYear();

	return (
		<>
			<footer className="sticky-footer">
				<Container>
					<Row className="no-gutters">
						<Col lg={6} sm={6}>
							<p className="mt-1 mb-0 ftc_text">
								&copy; Copyright {currentYear}{" "}
								<strong className="text-dark">autotrak LLC</strong>.
								All Rights Reserved &nbsp;&nbsp;&nbsp;<a href="https://autotrak.ai/privacy-policy.html" target="_blank">Privacy Policy</a>&nbsp;&nbsp;&nbsp;<a href="https://autotrak.ai/terms-service.html" target="_blank">Terms of Service</a>
							</p>
						</Col>
						{ /*<Col lg={6} sm={6} className="text-right">
							<div className="app">
								<a href="#" className="mr-1">
									<img alt="" src="img/google.png" />
								</a>
								<a href="#">
									<img alt="" src="img/apple.png" />
								</a>
							</div>
						</Col>
					*/}

					</Row>
				</Container>
			</footer>
		</>
	);
};

export default ThinFooter;
